import {
  ArrowsPointingOutIcon,
  ArrowsRightLeftIcon,
  ArrowTopRightOnSquareIcon,
  ChatBubbleLeftRightIcon,
  PlayPauseIcon,
  ShareIcon,
  SpeakerXMarkIcon,
  Squares2X2Icon,
  SquaresPlusIcon,
  VideoCameraIcon,
  VideoCameraSlashIcon,
} from "@heroicons/react/24/outline"

export const actions = [
  { id: "add", name: "Add...", icon: SquaresPlusIcon, shortcut: "a" },
  { id: "update", name: "Update...", icon: VideoCameraIcon, shortcut: "u" },
  { id: "remove", name: "Remove...", icon: VideoCameraSlashIcon, shortcut: "r" },
  { id: "focus", name: "Focus...", icon: ArrowsPointingOutIcon, shortcut: "f" },
  { id: "move", name: "Move...", icon: ArrowsRightLeftIcon, shortcut: "o" },
  { id: "layout", name: "Layout...", icon: Squares2X2Icon, shortcut: "l" },
  { id: "chat", name: "Chat...", icon: ChatBubbleLeftRightIcon, shortcut: "c" },
  { id: "playPause", name: "Play / Pause...", icon: PlayPauseIcon, shortcut: "p" },
  { id: "mute", name: "Mute...", icon: SpeakerXMarkIcon, shortcut: "m" },
  { id: "share", name: "Share...", icon: ShareIcon, shortcut: "s" },
  { id: "source", name: "View source video...", icon: ArrowTopRightOnSquareIcon, shortcut: "v" },
]

export function validateNewId(newId) {
  if (newId === "") return ""

  let validId = newId

  const preIds = ["https://www.youtube.com/watch?v=", "https://www.youtube.com/live/"]

  preIds.forEach((preId) => {
    if (newId.includes(preId)) {
      validId = newId.replace(preId, "")
    }
  })

  return validId.replace(/\?.*/, "")
}
